import {useSalesMarketingApi} from "./useSalesMarketingApi";

export const useCustomerBaseActions = () => {
    const {POST} = useSalesMarketingApi();

    async function getCustomerListBusinessConvention(search: string, id: string, otherFilters: string | undefined): Promise<any> {
        let params = {
            filters: {
                businessName: id=='customerName' && search ? search : undefined,
                firstName: id=='personName' && search ? search : id=='personSurname' && otherFilters ? otherFilters : undefined,
                lastName: id=='personSurname' && search ? search : id=='personName' && otherFilters ? otherFilters : undefined
            },
            start: 0,
            limit: 50
        };
        let data = await POST("sm/cb/search", params, false);
        let returnedValue = [];
        if (data && data.data) {
            if (id=='customerName'){
                let filteredData = data.data.filter((d:any) => d.registry && d.registry.businessName && d.bpCode);
                returnedValue = filteredData.map((r:any) => ({value: r.bpCode, label: r.registry?.businessName}));
            } else if (id=='personName'){
                let filteredData = data.data.filter((d:any) => d.registry && d.registry.firstName && d.bpCode);
                returnedValue = filteredData.map((r:any) => ({value: r.bpCode, label: r.registry?.firstName}));
            } else {
                let filteredData = data.data.filter((d:any) => d.registry && d.registry.lastName && d.bpCode);
                returnedValue = filteredData.map((r:any) => ({value: r.bpCode, label: r.registry?.lastName}));
            }
        }
        return returnedValue;
    }

    async function getCustomerList(search: string) {
        let params = {
            filters: {
                businessName: search ? search : undefined,
            },
            start: 0,
            limit: 50
        };
        let data = await POST("sm/cb/search", params, false);
        let returnedValue = [];
        if (data && data.data) {
            let filteredData = data.data.filter((d:any) => d.registry && d.registry.businessName && d.bpCode);
            returnedValue = filteredData.map((r:any) => ({value: r.bpCode, label: r.registry?.businessName}));
        }
        return returnedValue;
    }

    return {
        getCustomerList, getCustomerListBusinessConvention
    };
}